import { useEffect, useState, useRef } from 'react';

import { isInViewport } from 'app/shared/utils/utils';

export const useSlideIn = threshold => {
  const [mode, setMode] = useState(null);
  const prevMode = useRef(null);

  const handleScroll = () => {
    // Modal bounces up so it doesn't cover the "Zur detailsuche button" in the CLP
    const sidebar = document.querySelector('.sidebar__inner');
    const buttons = document.querySelectorAll('.sidebar__inner button');
    const lastButton = buttons[buttons.length - 1];
    const slideNow = window.scrollY > document.body.scrollHeight * threshold;
    const bounceNow =
      sidebar?.style.position === 'fixed' && isInViewport(lastButton);
    if (slideNow) setMode(bounceNow ? 'bounce' : 'slide');
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    prevMode.current = mode;
  });

  const changedToVisible = !!prevMode && mode === 'slide';

  return [mode, changedToVisible];
};
